import { Box, Grid, IconButton, ClickAwayListener, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Cancel } from '@mui/icons-material';
import React from 'react';
import propTypes from 'prop-types';
import moment from 'moment';
import { toUpper } from 'lodash';

const useStyles = (small) => {
  return makeStyles((theme) => ({
    stoppedHistoryPopup: {
      backgroundColor: 'rgba(0,0,0,.5)',
    },
    stoppedHistoryBody: {
      backgroundColor: theme.palette.white.main,
      maxWidth: '500px',
      padding: 8,
      paddingBottom: 32,
      borderRadius: 8,
      display: 'flex',
      flexDirection: 'column',
    },
    stoppedHistoryClose: {
      width: 30,
      height: 30,
    },
    stoppedItem: {
      paddingBlock: 16,
      display: 'flex',
      alignItems: 'center',
    },
    stoppedDate: {
      fontSize: theme.sizes.sm.t1,
    },
    body: {
      maxHeight: '300px',
      overflow: 'auto',
      '&::-webkit-scrollbar': {
        width: '1em',
      },
      '&::-webkit-scrollbar-track': {
        '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(0,0,0,.2)',
      },
    },
  }));
};

function StoppedHistoryPopup(props) {
  const { handleClose, history } = props;
  const classes = useStyles()();

  return (
    <Box
      className={classes.stoppedHistoryPopup}
      display="flex"
      justifyContent="center"
      alignItems="center"
      width="100%"
      position="fixed"
      top={0}
      left={0}
      height="100%"
      zIndex={15}
    >
      <ClickAwayListener onClickAway={handleClose}>
        <Grid container className={classes.stoppedHistoryBody}>
          <Box display="flex" justifyContent="space-between">
            <IconButton className={classes.stoppedHistoryClose} onClick={handleClose} size="large">
              <Cancel />
            </IconButton>
            <Box mr={2}>
              <img src="/logo512.png" width="30" alt="PrestoBots" />
            </Box>
          </Box>
          <Box mx={2} className={classes.body}>
            <Grid container>
              <Typography>
                <b>Historial de detenciones</b>
              </Typography>
              {!history || history.length === 0 ? (
                <Grid xs={12}>
                  <Typography>No hay detenciones aún</Typography>
                </Grid>
              ) : (
                history.map((item, index) => (
                  <Grid key={index} xs={12} className={classes.stoppedItem} container>
                    <Grid xs={8}>
                      <Box display="flex" flexDirection="column">
                        <Typography>
                          {item && item.user && toUpper(item.user) === 'BOT' ? 'BOT' : item.user}
                        </Typography>
                        <Typography className={classes.stoppedDate}>
                          {item &&
                            item.date &&
                            item.date.seconds &&
                            moment(item.date.seconds * 1000).format('LLLL')}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                ))
              )}
            </Grid>
          </Box>
        </Grid>
      </ClickAwayListener>
    </Box>
  );
}

const Props = {
  handleClose: propTypes.func,
  history: propTypes.array,
};

StoppedHistoryPopup.propTypes = Props;

export default StoppedHistoryPopup;
